import { ReactNode, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router";
import { RoutesContext } from "../../contexts/routes.context";
import authService from "../../services/auth/auth.service";

export interface GuardedRouteProps {
    children: ReactNode;
    notAllowedRoles?: { name: string; redirectRoute: string }[];
    noAuthNeeded?: boolean;
    returnAfterLogin?: boolean;
}

const GuardedRoute = ({
    children,
    notAllowedRoles,
    noAuthNeeded,
    returnAfterLogin,
}: GuardedRouteProps) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | undefined>();
    const { routes } = useContext(RoutesContext);
    const location = useLocation();

    useEffect(() => {
        setIsAuthenticated(authService.isAuthenticated());
    }, []);

    if (isAuthenticated === undefined) {
        // Optionally show loading while checking auth
        return null;
    }

    if (!isAuthenticated) {
        if (noAuthNeeded) {
            return <>{children}</>;
        } else {
            const loginPath = returnAfterLogin
                ? `${routes.auth.login}?returnUrl=${encodeURIComponent(location.pathname)}`
                : routes.auth.login;
            return <Navigate to={loginPath} replace />;
        }
    }

    // Authenticated user logic:
    const forbiddenRole = notAllowedRoles?.find((role) =>
        authService.isUserInRole(role.name)
    );
    if (forbiddenRole) {
        return <Navigate to={forbiddenRole.redirectRoute} replace />;
    }

    return <>{children}</>;
};

export default GuardedRoute;